<template>
    <div>
        <div class="hanoi-game">
            <div class="sticks-container">
                <div class="stick">
                    <div class="disks-container">                        
                        <div class="disk" data-size="1"><img src="images/games/tower-of-hanoi/disk01.png"/></div>
                        <div class="disk" data-size="2"><img src="images/games/tower-of-hanoi/disk02.png"/></div>
                        <div class="disk" data-size="3"><img src="images/games/tower-of-hanoi/disk03.png"/></div>
                        <div class="disk" data-size="4"><img src="images/games/tower-of-hanoi/disk04.png"/></div>
                        <div class="highlight"></div>
                    </div>
                    <div class="background"><span>A</span></div>
                </div>
                <div class="stick">
                    <div class="disks-container"><div class="highlight"></div></div>
                    <div class="background"><span>B</span></div>
                </div>
                <div class="stick">
                    <div class="disks-container"><div class="highlight"></div></div>
                    <div class="background"><span>C</span></div>
                </div>
                <span class="help-text">Kun je alle blokjes naar toren C schuiven?</span>
            </div>
            
        </div>
        <!-- <div v-show="gameEnded" class="continue-button-overlay">
            <span @click.prevent="onNext" class="continue-button">Verder ></span>
        </div> -->
    </div>
</template>

<script>
import Backend from '../../../services/Backend';
import Audio from '../../../services/Audio';
import Helper from '../../../services/Helper';

let REVERT_DURATION = 100;

class Stick {
    constructor(el) {
        this.$element   = $(el);
        this.$container = this.$element.find('.disks-container');
        
        this.$container.droppable({ 
            addClasses: false, 
            accept: '.disk', 
            drop: this.drop.bind(this),

        });

        this.$element.on('update', this.update.bind(this));

        this.update();
    }

    drop(_, ui) { 
        let $item = $(ui.draggable); 

        let topSize  = this.$disks.data('size') || Number.MAX_SAFE_INTEGER;
        let itemSize = $item.data('size');

        if (itemSize < topSize) {

            Audio.playSFX('swoosh-in');

            let offset = $item.offset();
            $item.prependTo(this.$container);
            $item.offset(offset);

            this.updateAll();
        }
    }

    updateAll() {
        this.$element.trigger('update-all');
    }

    update() {
        this.$disks.draggable('disable');
        this.$disks.first().draggable('enable');
    }

    destroy() {
        this.$container.droppable('destroy');
    }

    get $disks() {
        return this.$container.find('.disk');
    }
}

class Disk {
    constructor(el, containment) {
        this.$element = $(el).draggable({
            revert: true,
            revertDuration: REVERT_DURATION,
            containment: containment,
            start: this.start.bind(this)
        })
    }

    start() {
        Audio.playSFX('swoosh-out');
    }

    destroy() {
        this.$element.draggable('destroy');
    }
}

export default {
    'props': {
        data: {}
    },
    data()
    {
        return {
            game: null,
            disks: null,
            sticks: null,
            results: null,
            gameEnded: false,
        }
    },
    'watch': {
        data: {
            handler() {
            }
        }
    },
    'methods': {
        'update': function() {
            this.results.moves += 1;
            
            if (this.sticks[this.sticks.length - 1].$disks.length == this.disks.length) {
                this.finished()
            } else {
                this.sticks.forEach(s => s.$element.trigger('update'));
            }
        },
        'finished': function() {
            this.disks .forEach(d => d.destroy());
            this.sticks.forEach(s => s.destroy());
            
            this.results.time = (Date.now() - this.results.time) / 1000;

            this.$emit('complete', true);

            setTimeout(() => {
                console.table(this.results);

                this.$emit('answer', { 
                    questionId: this.data[0].question.id, 
                    answerParts: [ 
                        { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'moves').id, answerPart: this.results.moves + '' },
                        { answerId: Backend.MIA.getChoiceByLabel(this.data[0].question.choices, 'time').id, answerPart: this.results.time + '' },
                    ] 

                    
                });

                this.gameEnded = true;
            }, REVERT_DURATION * 2);
        },

        'onNext': function() {
            this.$emit("next");

            
        },
        'disableTouchMove': function(e) {
            e.preventDefault();
        }
    },
    mounted() {
        this.game = $(this.$el);

        this.disks  = Array.from(this.game.find('.disk' )).map(el => new Disk(el, this.$el));
        this.sticks = Array.from(this.game.find('.stick')).map(el => new Stick(el));

        this.results = Object.seal({ moves: 0, time: Date.now() });

        this.sticks.forEach(s => s.$element.on('update-all', this.update));

        Helper.disableTouchMove();
    },
    beforeDestroy() {
        Helper.enableTouchMove();
    }
}
</script>